export const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);

export const rate = (a?: number, b?: number) => {
  if (a === undefined && b === undefined) {
    return undefined
  }
  return ((a ?? 0) / (b || 1)).toFixed(2)
}

export const getFileType = (file: File | null) => {
  if (file?.type.startsWith('image/')) {
    return 'image'
  }
  if (file?.type.startsWith('video/')) {
    return 'video'
  }
  return null
}
